module.exports = ".error-text {\r\n  color: red;\r\n  font-weight: bold;\r\n  font-size: 12px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/license-portal/gis360/popup/generate-gis360-license/generate-gis360-license.component.css
// module id = 980
// module chunks = 1